const styleSheet = (theme: any) => ({
  circle: {
    height: "8px",
    width: "8px",
    margin: "0 auto",
    backgroundColor: "#085FE5",
    borderRadius: "100%"
  }
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/Table/TableSelectedItem/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/hoc/Table/TableSelectedItem/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }